import { defineComponent as _defineComponent } from 'vue'
import { ref } from "vue";
  import { formatPrice as formatMeters } from "@/helpers/transformation/price";

  
export default /*@__PURE__*/_defineComponent({
  __name: 'BuilderEstimatorFloorplansMobile',
  props: {
    floorplanUrl: {},
    area: {},
    width: {},
    length: {},
    features: {}
  },
  emits: ["openImageModal"],
  setup(__props: any, { expose: __expose }) {
  __expose();

  const props = __props;

  

  const expandedSections = ref({
    floorplan: false,
    floorPlanArea: false,
    features: false,
  } as Record<string, boolean>);

  const toggleSection = (section: string) => {
    expandedSections.value[section] = !expandedSections.value[section];
  };

const __returned__ = { props, expandedSections, toggleSection, ref, get formatMeters() { return formatMeters } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})